import styled from 'styled-components';
export var HighlightLabel = styled.span.withConfig({
  displayName: "HighlightLabel",
  componentId: "sc-11a323h-0"
})(["font-weight:", ";color:", ";"], function (_ref) {
  var _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'bolder' : _ref$weight;
  return weight;
}, function (_ref2) {
  var theme = _ref2.theme,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'secondary' : _ref2$color;
  return theme.colors[color];
});